import { translate, getCurrentPage, isComponentType } from '@avensia/excite';
import { addPackage } from '@avensia/excite-commercetools';
import { addBundle, addLineItemWithProductConfiguration } from 'webapp/pages/checkout/commands';
import { addLineItem } from 'webapp/pages/checkout/commands';
import type { CartCommandEventData } from '@avensia/excite-commercetools/cart/command';

type PropType = NordicNest.Api.ProductPageApiModel;

export type SelectedPart = Excite.Commercetools.PackagePartRequest & {
  variant: NordicNest.Api.VariantLinkApiModel;
};

export type PartPropType = {
  part: NordicNest.Api.PackagePartApiModel;
  variants: NordicNest.Api.VariantLinkApiModel[];
};

export function addToCart(
  setValidationMessage: (message: string | undefined) => void,
  props: PropType,
  quantity: number,
  button_location: string,
  packageParts?: Excite.Commercetools.PackagePartRequest[],
  productConfiguration?: { [item: string]: string },
): Promise<any> {
  return new Promise((resolve, reject) => {
    if (productConfiguration && Object.keys(productConfiguration).length > 0) {
      return addLineItemWithProductConfiguration(props.sku, productConfiguration, quantity).then(() =>
        resolve(undefined),
      );
    } else if (!props.isPackage && !props.isBundle) {
      return addLineItem(props.sku, quantity, {
        eventData: {
          sku: props.sku,
          itemIdentifier: props.ticket,
          additionalProductAttributes: {
            ecommerce: { button_location, button_name: 'add_to_cart' },
          },
        },
      }).then(respone => {
        const validation = respone as Excite.Commercetools.CartValidationApiModel;
        if (validation?.hasErrors) {
          if (validation.validationErrors.find(e => e.code === 'insufficient-inventory')) {
            setValidationMessage(translate(t => t.productStockStatus.outOfStockMessage));
          }
          reject();
        } else {
          setValidationMessage(undefined);
          resolve(respone);
        }
      });
    } else if (props.isBundle && props.bundleKey) {
      return addBundle(props.bundleKey, quantity).then(respone => {
        const validation = respone as Excite.Commercetools.CartValidationApiModel;
        if (validation?.hasErrors) {
          if (validation.validationErrors.find(e => e.code === 'insufficient-inventory')) {
            setValidationMessage(translate(t => t.productStockStatus.outOfStockMessage));
          }
          reject();
        }
        resolve(respone);
      });
    } else if (packageParts && props.packageKey) {
      return addPackage(props.packageKey, packageParts, quantity).then(respone => {
        const validation = respone as Excite.Commercetools.CartValidationApiModel;
        if (validation?.hasErrors) {
          if (validation.validationErrors.find(e => e.code === 'insufficient-inventory')) {
            setValidationMessage(translate(t => t.productStockStatus.outOfStockMessage));
          }
          reject();
        }
        resolve(respone);
      });
    } else if (props.quickBuyPackage) {
      const parts = Object.keys(props.quickBuyPackage.packagePartsWithOneChoice).map(key => ({
        packagePartKey: key,
        sku: props.quickBuyPackage?.packagePartsWithOneChoice[key] || '',
      }));

      return addPackage(props.quickBuyPackage.packageKey, parts, quantity).then(respone => {
        const validation = respone as Excite.Commercetools.CartValidationApiModel;
        if (validation?.hasErrors) {
          if (validation.validationErrors.find(e => e.code === 'insufficient-inventory')) {
            setValidationMessage(translate(t => t.productStockStatus.outOfStockMessage));
          }
          reject();
        }
        resolve(respone);
      });
    } else {
      reject();
    }
  });
}
